import dayjs from 'dayjs';
import { dateToString } from '../../../shared/utils/parseDate.js';
import { Delete } from '../../../features/DeleteEntity/index.js';

export const Review = ({ data, onDelete, onChangeVisible }) => {
  function padArrayToFive(arr) {
    while (arr.length < 5) {
      arr.push(null);
    }
    return arr;
  }

  return (
    <div className="review">
      <div className="review-header review-header-flex">
        <div className="review-user">
          <div className="review-avatar"></div>
          <div className="review-info">
            <div className="name">
              {data.user.name} {data.user.surname}
            </div>
            <div className="rating">
              {padArrayToFive([...Array(data.rate).keys()]).map((i) => (
                <div key={i} className="rating-var active">
                  <i className={`bi bi-star-fill ${i === null ? 'text-secondary' : ''}`}></i>
                </div>
              ))}
            </div>
          </div>
        </div>

        <div className="review-right">
          <div className="review-date">{dateToString(data.createdAt)}</div>
          {data.isHidden ? (
            <div className="review-status red">Скрыт</div>
          ) : (
            <div className="review-status green">Опубликован</div>
          )}

          <div className="actions">
            <button
              onClick={() => onChangeVisible(data.id, !data.isHidden)}
              className="action remove"
            >
              {data.isHidden ? (
                <i className="bi bi-shield-plus"></i>
              ) : (
                <i className="bi bi-ban"></i>
              )}
            </button>

            <button className="action remove">
              <Delete onConfirm={() => onDelete(data.id)} />
            </button>
          </div>
        </div>
      </div>

      <div className="review-body">
        <div className="title">{data.title}</div>
        <div className="content">{data.text}</div>
      </div>
    </div>
  );
};
